import React from 'react';
import numeral from 'numeral';
import AutoCompleteTextInput from '../../controls/autoCompleteTextInput.jsx';
import DropDownFilter from '../../grid/filter/dropdownFilter.jsx';
import SelectInput from "../../controls/selectInput.jsx";
import { apiGet, apiPost } from '../../services/apiClient';
import moment from 'moment';
import i18n from "../../services/i18n";
import { Trans } from "react-i18next";
export default class CalcPage extends React.Component {

    //TODO: !ВАЖНО! Если будем возвращать на калькулятор систему со своими индексами, то нужно прокинуть ShipmentCityId и DeliveryCityId аналогично тому, как сделано на новой форме создания посылки (v2).
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0,
            countries: null,
            currentLanguage: 'ru',
            isDocument: true,
            documentWeight: 0.1,
            shipmentAddress: null,
            shipmentAddressName: null,
            shipmentAddressCountry: null,
            deliveryAddress: null,
            deliveryAddressName: null,
            deliveryAddressCountry: null,
            cargoLength: 10,
            cargoWidth: 10,
            cargoHeight: 10,
            cargoWeight: 1,
            cargoVolume: 0.1,
            cargoPackages: 1,
            departureDate: moment().add(1, 'days').format('YYYY-MM-DD'),
            entries: null,
            errors: {}
        };
        i18n.changeLanguage(this.state.currentLanguage);

    }

    componentDidMount() {
        //this.reload();
        (function (m, e, t, r, i, k, a) {
            m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) };
            m[i].l = 1 * new Date();
            k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
        })
            (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
        ym(55485361, "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true
        });
    }

    reload() {
        this.updateBusyCount(1);
        apiGet('ref/countries/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.countries = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    let ruCountry = prevState.countries.find(e => e.label === 'RU');
                    if (ruCountry !== undefined && ruCountry !== null) {
                        prevState.shipmentAddressCountry = { Id: ruCountry.value, Code: ruCountry.label }
                        prevState.deliveryAddressCountry = { Id: ruCountry.value, Code: ruCountry.label }
                    }
                    return prevState;
                });
            });

    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    handleParcelTypeSwitch(isDocument) {
        this.setState({
            isDocument: isDocument
        });
    }

    loadAddressSuggestions(text, sessionKey/*, countryCode*/) {
        return apiPost('parcels/addresses/suggestions', { text: text, sessionKey: sessionKey, maxCount: 10, /*countryCode: countryCode, */source: 1 })
            .then(data => data.entries);
    }

    handleShipmentAddressSelect(item) {
        this.setState({
            shipmentAddress: item,
            shipmentAddressName: item.fullName,
            entries: null
        });
    }

    handleShipmentAddressChange(value) {
        this.setState({
            shipmentAddress: null,
            shipmentAddressName: value,
            entries: null
        });
    }

    handleDeliveryAddressSelect(item) {
        this.setState({
            deliveryAddress: item,
            deliveryAddressName: item.fullName,
            entries: null
        });
    }

    handleDeliveryAddressChange(value) {
        this.setState({
            deliveryAddress: null,
            deliveryAddressName: value,
            entries: null
        });
    }

    handleDocumentWeight(value) {
        this.setState({
            documentWeight: value,
            entries: null
        });
    }

    handleWeight(value) {
        this.setState({
            cargoWeight: value,
            entries: null
        });
    }

    handleVolume(value) {
        this.setState({
            cargoVolume: value,
            entries: null
        });
    }

    handlePackages(value) {
        this.setState({
            cargoPackages: value,
            entries: null
        });
    }

    calcVolume(length, width, height) {
        this.setState({
            cargoLength: length,
            cargoWidth: width,
            cargoHeight: height,
            cargoVolume: (length * width * height * 0.000001).toFixed(3),
            entries: null

        });
    }

    validateForm() {
        let errors = null;

        if (this.state.shipmentAddressName === null || this.state.shipmentAddressName === undefined || this.state.shipmentAddressName.length < 1) {
            errors = errors ? errors : {};
            errors["shipmentAddress"] = "Нужно указать Адрес/город отправления.";
        } else if (this.state.shipmentAddress === null || this.state.shipmentAddress === undefined) {
            errors = errors ? errors : {};
            errors["shipmentAddress"] = "Нужно выбрать Адрес/город отправления из предложенных вариантов выпадающего списка.";
        }

        if (this.state.deliveryAddressName === null || this.state.deliveryAddressName === undefined || this.state.deliveryAddressName.length < 1) {
            errors = errors ? errors : {};
            errors["deliveryAddress"] = "Нужно указать Адрес/город доставки.";
        } else if (this.state.deliveryAddress === null || this.state.deliveryAddress === undefined) {
            errors = errors ? errors : {};
            errors["deliveryAddress"] = "Нужно выбрать Адрес/город доставки из предложенных вариантов выпадающего списка.";
        }

        if (this.state.isDocument) {
            if (this.state.documentWeight === null || this.state.documentWeight === undefined || this.state.documentWeight.length < 1) {
                errors = errors ? errors : {};
                errors["documentWeight"] = " ";
            }
        } else {
            if (this.state.cargoVolume === null || this.state.cargoVolume === undefined || this.state.cargoVolume.length < 1) {
                errors = errors ? errors : {};
                errors["cargoVolume"] = " ";
            }

            if (this.state.cargoWeight === null || this.state.cargoWeight === undefined || this.state.cargoWeight.length < 1) {
                errors = errors ? errors : {};
                errors["cargoWeight"] = " ";
            }

            if (this.state.cargoPackages === null || this.state.cargoPackages === undefined || this.state.cargoPackages.length < 1) {
                errors = errors ? errors : {};
                errors["cargoPackages"] = " ";
            }
        }

        return errors;
    }

    onFindTariffs() {
        let errors = this.validateForm();
        if (errors) {
            this.setState({ errors });
        } else {
            this.updateBusyCount(1);
            this.setState(
                {
                    errors: {},
                    entries: []
                },
                () => {
                    this.loadTariffs()
                        .then(() => this.updateBusyCount(-1))
                        .catch(() => this.updateBusyCount(-1));
                }
            );
        }
    }

    getCostModel() {
        return {
            onlyCompleteCosts: true,
            hideNames: true,
            from: this.state.shipmentAddress,
            to: this.state.deliveryAddress,
            take: 3,
            parcelType: this.state.isDocument ? 1 : 2,
            documentWeight: this.state.documentWeight,
            weight: this.state.cargoWeight,
            volume: this.state.cargoVolume,
            length: this.state.cargoLength,
            height: this.state.cargoHeight,
            width: this.state.cargoWidth,
            packages: this.state.cargoPackages
        };
    }

    loadTariffs() {
        let requestData = this.getCostModel();
        let promise = new Promise((resolve, reject) => {
            apiGet('carriers/calc/list')
                .then(response => {
                    if (response.entries) {
                        let loadingCount = 0;
                        response.entries.forEach((entry, ind, arr) => {
                            if (entry.hasIntegration) {
                                ++loadingCount;
                                apiPost('carriers/calc/costs/' + entry.id, requestData)
                                    .then(response => {
                                        --loadingCount;
                                        if (response.tariffs) {
                                            this.setState((state) => {
                                                let newEntries = state.entries.concat(response.tariffs);
                                                newEntries.sort((a, b) => a.cost - b.cost);
                                                return { entries: newEntries.slice(0, 3) };
                                            });
                                        }
                                        if (loadingCount === 0) {
                                            resolve();
                                        }
                                    })
                                    .catch(err => {
                                        --loadingCount;
                                        if (loadingCount === 0) {
                                            resolve();
                                        }
                                    });
                            }
                        });
                        if (loadingCount === 0) {
                            resolve();
                        }
                    }
                    else {
                        resolve();
                    }
                })
                .catch(err => reject(err));
        });
        return promise;
    }

    declOfNum(number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }

    renderDays(number, currentLanguage) {
        if (currentLanguage === "ru") {
            return (<span>{number} {this.declOfNum(number, ['день', 'дня', 'дней'])}</span>);
        }
        else if (currentLanguage === "en") {
            return (<span>{number} days</span>);
        }
        return null;
    }

    renderLogo() {
        return (
            <svg width="226" height="68" viewBox="0 0 226 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M83.789 48.3829C80.289 48.3829 77.559 47.4146 75.599 45.4779C73.6624 43.5412 72.694 40.7762 72.694 37.1829V23.4629H78.364V36.9729C78.364 41.3596 80.184 43.5529 83.824 43.5529C85.5974 43.5529 86.9507 43.0279 87.884 41.9779C88.8174 40.9046 89.284 39.2362 89.284 36.9729V23.4629H94.884V37.1829C94.884 40.7762 93.904 43.5412 91.944 45.4779C90.0074 47.4146 87.289 48.3829 83.789 48.3829ZM111.547 28.8529C113.88 28.8529 115.759 29.5529 117.182 30.9529C118.629 32.3529 119.352 34.4296 119.352 37.1829V47.9629H113.892V38.0229C113.892 36.5296 113.565 35.4212 112.912 34.6979C112.259 33.9512 111.314 33.5779 110.077 33.5779C108.7 33.5779 107.604 34.0096 106.787 34.8729C105.97 35.7129 105.562 36.9729 105.562 38.6529V47.9629H100.102V29.1329H105.317V31.3379C106.04 30.5446 106.939 29.9379 108.012 29.5179C109.085 29.0746 110.264 28.8529 111.547 28.8529ZM124.301 29.1329H129.761V47.9629H124.301V29.1329ZM127.031 26.5079C126.028 26.5079 125.211 26.2162 124.581 25.6329C123.951 25.0496 123.636 24.3262 123.636 23.4629C123.636 22.5996 123.951 21.8762 124.581 21.2929C125.211 20.7096 126.028 20.4179 127.031 20.4179C128.035 20.4179 128.851 20.6979 129.481 21.2579C130.111 21.8179 130.426 22.5179 130.426 23.3579C130.426 24.2679 130.111 25.0262 129.481 25.6329C128.851 26.2162 128.035 26.5079 127.031 26.5079ZM142.99 48.3829C141.053 48.3829 139.175 48.1262 137.355 47.6129C135.558 47.0762 134.112 46.3879 133.015 45.5479L134.94 41.2779C135.99 42.0479 137.238 42.6662 138.685 43.1329C140.132 43.5996 141.578 43.8329 143.025 43.8329C144.635 43.8329 145.825 43.5996 146.595 43.1329C147.365 42.6429 147.75 42.0012 147.75 41.2079C147.75 40.6246 147.517 40.1462 147.05 39.7729C146.607 39.3762 146.023 39.0612 145.3 38.8279C144.6 38.5946 143.643 38.3379 142.43 38.0579C140.563 37.6146 139.035 37.1712 137.845 36.7279C136.655 36.2846 135.628 35.5729 134.765 34.5929C133.925 33.6129 133.505 32.3062 133.505 30.6729C133.505 29.2496 133.89 27.9662 134.66 26.8229C135.43 25.6562 136.585 24.7346 138.125 24.0579C139.688 23.3812 141.59 23.0429 143.83 23.0429C145.393 23.0429 146.922 23.2296 148.415 23.6029C149.908 23.9762 151.215 24.5129 152.335 25.2129L150.585 29.5179C148.322 28.2346 146.058 27.5929 143.795 27.5929C142.208 27.5929 141.03 27.8496 140.26 28.3629C139.513 28.8762 139.14 29.5529 139.14 30.3929C139.14 31.2329 139.572 31.8629 140.435 32.2829C141.322 32.6796 142.663 33.0762 144.46 33.4729C146.327 33.9162 147.855 34.3596 149.045 34.8029C150.235 35.2462 151.25 35.9462 152.09 36.9029C152.953 37.8596 153.385 39.1546 153.385 40.7879C153.385 42.1879 152.988 43.4712 152.195 44.6379C151.425 45.7812 150.258 46.6912 148.695 47.3679C147.132 48.0446 145.23 48.3829 142.99 48.3829ZM175.319 38.6179C175.319 38.6879 175.284 39.1779 175.214 40.0879H160.969C161.226 41.2546 161.833 42.1762 162.789 42.8529C163.746 43.5296 164.936 43.8679 166.359 43.8679C167.339 43.8679 168.203 43.7279 168.949 43.4479C169.719 43.1446 170.431 42.6779 171.084 42.0479L173.989 45.1979C172.216 47.2279 169.626 48.2429 166.219 48.2429C164.096 48.2429 162.218 47.8346 160.584 47.0179C158.951 46.1779 157.691 45.0229 156.804 43.5529C155.918 42.0829 155.474 40.4146 155.474 38.5479C155.474 36.7046 155.906 35.0479 156.769 33.5779C157.656 32.0846 158.858 30.9296 160.374 30.1129C161.914 29.2729 163.629 28.8529 165.519 28.8529C167.363 28.8529 169.031 29.2496 170.524 30.0429C172.018 30.8362 173.184 31.9796 174.024 33.4729C174.888 34.9429 175.319 36.6579 175.319 38.6179ZM165.554 32.9829C164.318 32.9829 163.279 33.3329 162.439 34.0329C161.599 34.7329 161.086 35.6896 160.899 36.9029H170.174C169.988 35.7129 169.474 34.7679 168.634 34.0679C167.794 33.3446 166.768 32.9829 165.554 32.9829ZM190.4 28.8529C192.733 28.8529 194.611 29.5529 196.035 30.9529C197.481 32.3529 198.205 34.4296 198.205 37.1829V47.9629H192.745V38.0229C192.745 36.5296 192.418 35.4212 191.765 34.6979C191.111 33.9512 190.166 33.5779 188.93 33.5779C187.553 33.5779 186.456 34.0096 185.64 34.8729C184.823 35.7129 184.415 36.9729 184.415 38.6529V47.9629H178.955V29.1329H184.17V31.3379C184.893 30.5446 185.791 29.9379 186.865 29.5179C187.938 29.0746 189.116 28.8529 190.4 28.8529ZM222.539 21.9929V47.9629H217.324V45.7929C215.971 47.4262 214.011 48.2429 211.444 48.2429C209.671 48.2429 208.061 47.8462 206.614 47.0529C205.191 46.2596 204.071 45.1279 203.254 43.6579C202.437 42.1879 202.029 40.4846 202.029 38.5479C202.029 36.6112 202.437 34.9079 203.254 33.4379C204.071 31.9679 205.191 30.8362 206.614 30.0429C208.061 29.2496 209.671 28.8529 211.444 28.8529C213.847 28.8529 215.726 29.6112 217.079 31.1279V21.9929H222.539ZM212.389 43.7629C213.766 43.7629 214.909 43.2962 215.819 42.3629C216.729 41.4062 217.184 40.1346 217.184 38.5479C217.184 36.9612 216.729 35.7012 215.819 34.7679C214.909 33.8112 213.766 33.3329 212.389 33.3329C210.989 33.3329 209.834 33.8112 208.924 34.7679C208.014 35.7012 207.559 36.9612 207.559 38.5479C207.559 40.1346 208.014 41.4062 208.924 42.3629C209.834 43.2962 210.989 43.7629 212.389 43.7629Z" fill="#424D7A" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3744 23.7446C25.8731 23.8487 26.3701 23.5625 26.5291 23.0797L33.9039 0.68628C34.0695 0.183269 34.5999 -0.102821 35.1128 0.0342201L38.9815 1.06807C39.5333 1.21551 39.8504 1.79286 39.6779 2.33593L30.7738 30.368C30.6175 30.8599 30.1114 31.1515 29.606 31.0408L0.787798 24.7288C0.229657 24.6066 -0.113487 24.0438 0.0344221 23.4933L1.07088 19.6356C1.20829 19.1241 1.72191 18.8091 2.24153 18.9175L25.3744 23.7446ZM44.4389 33.2102C44.098 33.5902 44.098 34.1658 44.4389 34.5457L60.1917 52.1062C60.5467 52.502 60.5299 53.1065 60.1534 53.482L57.321 56.3068C56.9182 56.7085 56.2619 56.6938 55.8776 56.2743L35.9878 34.5677C35.6377 34.1856 35.6375 33.5993 35.9874 33.217L55.8777 11.4825C56.2619 11.0626 56.9186 11.0477 57.3215 11.4496L60.1535 14.2739C60.53 14.6494 60.5468 15.2539 60.1917 15.6497L44.4389 33.2102ZM25.6423 44.2554C26.141 44.1513 26.6381 44.4375 26.7971 44.9203L34.1718 67.3138C34.3375 67.8168 34.8679 68.1029 35.3807 67.9659L39.2488 66.9322C39.8008 66.7847 40.1179 66.2069 39.945 65.6637L31.0169 37.6173C30.8604 37.1255 30.354 36.8342 29.8488 36.9452L1.055 43.2707C0.49718 43.3932 0.154395 43.9558 0.30224 44.5061L1.33887 48.3644C1.47628 48.8759 1.9899 49.1909 2.50952 49.0825L25.6423 44.2554Z" fill="#424D7A" />
            </svg>
        );
    }

    switchLanguage(current) {
        let newLanguage = current === 'en' ? 'ru' : 'en';
        this.setState({
            currentLanguage: newLanguage
        });
        i18n.changeLanguage(newLanguage);
    }

    renderLanguageSwitch() {
        if (this.state.currentLanguage === 'en') {
            return (
                <div className="calc-lang-switch" onClick={() => this.switchLanguage(this.state.currentLanguage)}>
                    <img src="/img/en.png" width="12" height="12" />
                    <span>En</span>
                </div>
            );
        }
        if (this.state.currentLanguage === 'ru') {
            return (
                <div className="calc-lang-switch" onClick={() => this.switchLanguage(this.state.currentLanguage)}>
                    <img src="/img/ru.png" width="12" height="12" />
                    <span>Ru</span>
                </div>
            );
        }

    }

    renderCargoTab() {
        let isBusy = this.state.busyCount > 0;
        return (
            <div className="row">
                <table className="calc-cargo-table">
                    <tbody>
                        <tr>
                            <td className="calc-cargo-td-field-table">
                                <label><Trans>Length</Trans></label>
                                <input type="text"
                                    className="form-control"
                                    value={this.state.cargoLength}
                                    onChange={event => this.calcVolume(event.target.value, this.state.cargoWidth, this.state.cargoHeight)}
                                    disabled={isBusy} />
                            </td>
                            <td><span className="fa fa-times text-purple calc-multiply"></span></td>
                            <td className="calc-cargo-td-field-table">
                                <label><Trans>Width</Trans></label>
                                <input type="text"
                                    className="form-control"
                                    onChange={event => this.calcVolume(this.state.cargoLength, event.target.value, this.state.cargoHeight)}
                                    value={this.state.cargoWidth}
                                    disabled={isBusy}
                                />
                            </td>
                            <td><span className="fa fa-times text-purple calc-multiply"></span></td>
                            <td className="calc-cargo-td-field-table">
                                <label><Trans>Height</Trans></label>
                                <input type="text"
                                    className="form-control"
                                    onChange={event => this.calcVolume(this.state.cargoLength, this.state.cargoWidth, event.target.value)}
                                    value={this.state.cargoHeight}
                                    disabled={isBusy}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td className={"calc-cargo-td-field-table" + (this.state.errors.cargoWeight ? " has-error" : "")}>
                                <label><Trans>Weight</Trans></label>
                                <input type="text"
                                    className="form-control"
                                    value={this.state.cargoWeight}
                                    onChange={event => this.handleWeight(event.target.value)}
                                    disabled={isBusy} />
                            </td>
                            <td></td>
                            <td className={"calc-cargo-td-field-table" + (this.state.errors.cargoVolume ? " has-error" : "")}>
                                <label><Trans>Volume</Trans></label>
                                <input type="text"
                                    className="form-control"
                                    value={this.state.cargoVolume}
                                    onChange={event => this.handleVolume(event.target.value)}
                                    disabled={isBusy}
                                />
                            </td>
                            <td></td>
                            <td className={"calc-cargo-td-field-table" + (this.state.errors.cargoPackages ? " has-error" : "")}>
                                <label><Trans>PackageCount</Trans></label>
                                <input type="text"
                                    className="form-control"
                                    value={this.state.cargoPackages}
                                    onChange={event => this.handlePackages(event.target.value)}
                                    disabled={isBusy}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderTariff(entry, ind, currentLanguage) {
        let entryCost = entry.cost ? numeral(entry.cost).format("0.00") : '';
        let deliveryDays;
        if (entry.maxDeliveryDay !== undefined && entry.maxDeliveryDay !== "") {
            deliveryDays = <div><Trans>{entry.minDeliveryDay}</Trans><span> - </span><Trans>{entry.maxDeliveryDay}</Trans></div>;
        } else {
            deliveryDays = <div><Trans>{entry.minDeliveryDay}</Trans></div>;
        }
        // hide column: <td>{entry.carrierName}</td>
        return (
            <tr key={'cost-entry-' + ind}>
                <td>{entry.departureDate}<span className="calc-week-day"><Trans>{entry.departureDay}</Trans></span></td>
                <td>{this.renderDays(entry.maxDays, currentLanguage)}</td>
                <td>{entry.deliveryTime}<span className="calc-week-day">{deliveryDays}</span></td>
                <td>{entryCost} ₽</td>
                <td style={{ verticalAlign: 'middle' }}><a className="calc-btn" href="https://unisend.ru/form"><Trans>Select</Trans></a></td>
            </tr>
        );
    }

    renderTableTariffs(isBusy) {
        if (this.state.entries === undefined || this.state.entries === null)
            return <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="col-md-12">
                    <button className="calc-btn calc-btn-active" onClick={() => this.onFindTariffs()}>
                        <Trans>GetShippingRates</Trans>
                    </button>
                </div>
            </div>;

        if (!isBusy && this.state.entries != undefined && this.state.entries.length === 0) {
            return (
                <div className="text-center">
                    <span className="calc-h2"><Trans>NotFoundResults</Trans></span>
                </div>
            );
        }

        // hide column: <th><b>Перевозчик</b></th>
        return (
            <div className="row">
                <div className="col-md-9">
                    <div className="box calc-box" style={{ minHeight: 500 }}>
                        <div className="calc-box-header">
                            <span style={{ marginLeft: 7 }}><Trans>Tariffs</Trans></span>
                            {isBusy
                                ? <img src="/img/spinner.gif" alt="loading" width="40" height="40" style={{ marginTop: "-16px", marginBottom: "-10px" }} />
                                : null
                            }
                        </div>
                        <div className="box-body">
                            <div className="calc-form-group" style={{ marginLeft: 7 }}>
                                <label><Trans>PickupDate</Trans></label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-calendar"></i></span>
                                    <input type="date" style={{ width: 160 }}
                                        className="form-control"
                                        value={this.state.departureDate}
                                        readonly="true" disabled="disabled" />
                                </div>
                            </div>
                            <table className="table tariff-table">
                                <thead>
                                    <tr>
                                        <th><b><Trans>PickupDate</Trans></b></th>
                                        <th><b><Trans>DeliveryDays</Trans></b></th>
                                        <th><b><Trans>DeliveryDate</Trans></b></th>
                                        <th><b><Trans>Tariff</Trans></b> <Trans>VAT</Trans></th>
                                        <th style={{ width: 115 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.entries ? this.state.entries.map((entry, index) => this.renderTariff(entry, index, this.state.currentLanguage)) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="box calc-box" style={{ height: 230 }}>
                        <div className="calc-box-header">
                            <span><Trans>Services</Trans></span>
                        </div>
                        <div className="box-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="radio">
                                        <label>
                                            <input
                                                type="radio"
                                                value="doortodoor"
                                                checked={true}
                                            />
                                            <Trans>DoorToDoorDelivery</Trans>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    //renderCountryOption(option) {
    //    return (
    //        <div className="Select-value">
    //            <div className={"country-icon-" + option.label.toLowerCase()}></div>
    //            <span className="Select-value-label" role="option" aria-selected="true" id="react-select-2--value-item">{option.label}</span>
    //        </div>
    //    );
    //}

    render() {
        let isBusy = this.state.busyCount > 0;
        return (
            <div>
                <section className="container">
                    <div className="row">
                        <div className="col-lg-12 calc-header">
                            <div className="pull-left">
                                {this.renderLogo()}
                            </div>
                            <div className="pull-right">
                                {this.renderLanguageSwitch()}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 col-xs-12">
                            <div className="box calc-box" style={{ height: 246 }}>
                                <div className="calc-box-header">
                                    <div className="toggle-group">
                                        <span className={"toggle-button " + (this.state.isDocument ? 'toggle-active' : '')} onClick={() => this.handleParcelTypeSwitch(true)} ><Trans>Documents</Trans></span>
                                        <span className={"toggle-button " + (!this.state.isDocument ? 'toggle-active' : '')} onClick={() => this.handleParcelTypeSwitch(false)}><Trans>Cargo</Trans></span>
                                    </div>
                                </div>
                                <div className="box-body">
                                    {this.state.isDocument &&
                                        <div className="row">
                                            <div className={"col-xs-12" + (this.state.errors.documentWeight ? " has-error" : "")}>
                                                <div className="calc-form-group">
                                                    <label><Trans>Weight</Trans></label>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={this.state.documentWeight}
                                                        onChange={event => this.handleDocumentWeight(event.target.value)}
                                                        disabled={isBusy}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {!this.state.isDocument &&
                                        this.renderCargoTab()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 col-xs-12">
                            <div className="box calc-box" style={{ height: 113 }}>
                                <div className="calc-box-header">
                                    <span><Trans>PickupFrom</Trans></span>
                                </div>
                                <div className="box-body">
                                    <div className="row">
                                        <div className={"col-xs-12" + (this.state.errors.shipmentAddress ? " has-error" : "")}>
                                            <AutoCompleteTextInput id="inputShipmentAddress"
                                                className="calc-input"
                                                title={this.state.errors.shipmentAddress}
                                                value={this.state.shipmentAddressName}
                                                getItemKey={item => item.fias}
                                                getItemValue={item => item.fullName}
                                                onChange={value => this.handleShipmentAddressChange(value)}
                                                onItemSelect={item => this.handleShipmentAddressSelect(item)}
                                                loadItems={(text, sessionKey) => this.loadAddressSuggestions(text, sessionKey)}
                                                disabled={isBusy}
                                                isItemSelected={this.state.shipmentAddress !== null}
                                                i18nPlaceholder={'StartEnterAddress'}
                                                groupIcon={<i className="fa fa-search"></i>}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box calc-box" style={{ height: 113 }}>
                                <div className="calc-box-header">
                                    <span><Trans>DeliverTo</Trans></span>
                                </div>
                                <div className="box-body">
                                    <div className="row">
                                        <div className={"col-xs-12" + (this.state.errors.deliveryAddress ? " has-error" : "")}>
                                            <AutoCompleteTextInput id="inputDeliveryAddress"
                                                className="calc-input"
                                                title={this.state.errors.deliveryAddress}
                                                value={this.state.deliveryAddressName}
                                                getItemKey={item => item.fias}
                                                getItemValue={item => item.fullName}
                                                onChange={value => this.handleDeliveryAddressChange(value)}
                                                onItemSelect={item => this.handleDeliveryAddressSelect(item)}
                                                loadItems={(text, sessionKey) => this.loadAddressSuggestions(text, sessionKey)}
                                                disabled={isBusy}
                                                isItemSelected={this.state.deliveryAddress !== null}
                                                i18nPlaceholder={'StartEnterAddress'}
                                                groupIcon={<i className="fa fa-search"></i>}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.renderTableTariffs(isBusy)}

                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/calc/calcPage.jsx